module.exports = __webpack_public_path__ + "static/media/copy.3e0af8a6.svg";